import proyecto from "../../api/Proyecto";

export const getCajas = async () => {
  const response = await proyecto.get("/cajas");
  return response.data;
};

